export default __webpack_public_path__ + "static/media/hyperdev.af1dfff9.svg";